export default __webpack_public_path__ + "static/media/nyoko.af75dfff.png";